module.exports = __webpack_public_path__ + "img/21.73e87fe2.png";